import { Component, Inject } from '@angular/core';
import { StateService } from "@uirouter/angular";
import { RoleTypeDataService } from "../../core/jobroletypes.dataservice";
import { MatDialog } from "@angular/material/dialog";
import { DetailsBase } from "../shared/details.base";

@Component({
    selector: "crew-jobroletype",
    template: require('../shared/details-view.html')
})
export class JobRoleType extends DetailsBase<Nema.Crew.Model.RoleType> {
    constructor(
        stateService: StateService,
        dialog: MatDialog,
        @Inject('jobRoleType') jobRoleType: Nema.Crew.Model.RoleType,
        @Inject(RoleTypeDataService.Id) roleTypeDataService: RoleTypeDataService,
        @Inject('$log') $log: ng.ILogService) {

        super(stateService, dialog, jobRoleType, roleTypeDataService, $log);
    }

    public entityName = "Job Role";

    public editStateName = "app.settings.jobroletypes.edit";

    public listStateName = "app.settings.jobroletypes";
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./client/app/settings/jobroletypes/jobroletype.component.ts